"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListGroupItem = void 0;
var _reactstrap = require("reactstrap");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var ListGroupItem = (0, _styledComponents.default)(_reactstrap.ListGroupItem)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border: none;\n  padding: 0;\n"])));
exports.ListGroupItem = ListGroupItem;